import React from 'react';
import styled from 'styled-components';

/**
 * Component that renders the Spinner of a loader
 *
 * @component LoadSpinner
 *
 * @param {object} props
 *
 * @prop {number} size
 */
const LoadSpinner = props => {
  const { size = 40 } = props;

  return (
    <LoaderWrapper>
      <Spinner size={size} />
    </LoaderWrapper>
  );
};

const LoaderWrapper = styled.div`
  position: relative;
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;
const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #222;
  border-radius: 50%;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  animation: spin 2s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default LoadSpinner;
